import { defineComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, resolveDynamicComponent, createCommentVNode, createElementVNode, createTextVNode, toDisplayString, createVNode, unref } from "vue";
import ChevronRightIcon from "../../assets/icons/chevron-right.svg.js";
const _hoisted_1 = {
  key: 0,
  class: "profile-dropdown-menu-item__icon"
};
const _hoisted_2 = { class: "profile-dropdown-menu-item__label" };
const _hoisted_3 = {
  key: 1,
  class: "profile-dropdown-menu-item__chevron",
  "aria-hidden": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProfileDropdownMenuItem",
  props: {
    icon: {},
    label: {},
    variant: { default: "default" },
    hasChildren: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const handleClick = () => {
      emit("click");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        class: normalizeClass(["profile-dropdown-menu-item", `profile-dropdown-menu-item--${__props.variant}`]),
        onClick: handleClick
      }, [
        _ctx.$slots.icon || __props.icon ? (openBlock(), createElementBlock("span", _hoisted_1, [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            __props.icon ? (openBlock(), createBlock(resolveDynamicComponent(__props.icon), { key: 0 })) : createCommentVNode("", true)
          ], true)
        ])) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_2, [
          renderSlot(_ctx.$slots, "default", {}, () => [
            createTextVNode(toDisplayString(__props.label), 1)
          ], true)
        ]),
        __props.hasChildren ? (openBlock(), createElementBlock("span", _hoisted_3, [
          createVNode(unref(ChevronRightIcon))
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProfileDropdownMenuItem.vue2.js.map
